module.exports = __webpack_public_path__ + "static/media/plant.e56e5e5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/plant.svg
// module id = 1118
// module chunks = 38